import { getToken } from "./auth.service";

const API_URL = (process.env.REACT_APP_API_URL || "").trim();

function headers(): Record<string, string> {
  return {
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
  };
}

export async function getKommoConfig() {
  const res = await fetch(`${API_URL}/kommo/config`, { headers: headers() });
  if (!res.ok) throw new Error(`Erro ${res.status}`);
  return res.json();
}

export async function saveKommoConfig(config: {
  clientId?: string;
  clientSecret?: string;
  subdomain?: string;
  accessToken?: string;
  refreshToken?: string;
  pipelineId?: number;
  statusId?: number;
}) {
  const res = await fetch(`${API_URL}/kommo/config`, {
    method: "PUT",
    headers: headers(),
    body: JSON.stringify(config),
  });
  if (!res.ok) throw new Error(`Erro ${res.status}`);
  return res.json();
}

export async function getKommoPipelines(): Promise<{ id: number; name: string }[]> {
  const res = await fetch(`${API_URL}/kommo/pipelines`, { headers: headers() });
  if (!res.ok) return [];
  return res.json();
}

export async function getKommoStatuses(pipelineId: number): Promise<{ id: number; name: string }[]> {
  const res = await fetch(`${API_URL}/kommo/pipelines/${pipelineId}/statuses`, { headers: headers() });
  if (!res.ok) return [];
  return res.json();
}

export async function checkKommoConnection(): Promise<{ connected: boolean; account?: string }> {
  const res = await fetch(`${API_URL}/kommo/connection`, { headers: headers() });
  if (!res.ok) return { connected: false };
  return res.json();
}

export function normalizeInstagram(value: string): string {
  if (!value || !value.trim()) return "";
  let cleaned = value.trim();
  cleaned = cleaned.replace(/^https?:\/\/(www\.)?instagram\.com\//, "");
  cleaned = cleaned.replace(/\/$/, "");
  cleaned = cleaned.replace(/^@/, "");
  return cleaned ? `@${cleaned}` : "";
}

export async function syncUserToKommo(
  userId: number,
  data: {
    name?: string;
    email?: string;
    phone?: string;
    instagram_url?: string;
    brand_name?: string;
    brand_description?: string;
    brand_items?: string;
    cpf?: string;
    cnpj?: string;
    city?: string;
    state?: string;
  },
): Promise<any> {
  const res = await fetch(`${API_URL}/users/${userId}/sync-kommo`, {
    method: "POST",
    headers: headers(),
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(`Erro ${res.status}`);
  return res.json();
}

export async function importCsvToKommo(
  rows: {
    name: string;
    email: string;
    phone: string;
    cpf?: string;
    cnpj?: string;
    instagram_url?: string;
    brand_name?: string;
    brand_description?: string;
    brand_items?: string;
    city?: string;
    state?: string;
    zipcode?: string;
    address?: string;
    address_number?: number;
    address_complement?: string;
    district?: string;
  }[],
): Promise<{ success: number; failed: number; errors: { row: number; email: string; error: string }[] }> {
  const res = await fetch(`${API_URL}/kommo/import-csv`, {
    method: "POST",
    headers: headers(),
    body: JSON.stringify({ rows }),
  });
  if (!res.ok) throw new Error(`Erro ${res.status}`);
  return res.json();
}
